import { getProductType, ProductEnum } from "../constants/login";
import { golfExcelExportSheets } from "./products/golf";
import { reserveExcelExportSheets } from "./products/reserve";
import { retailExcelExportSheets } from "./products/retail";
import { sncExcelExportSheets } from "./products/snc";
import { spaExcelExportSheets } from "./products/spa";
import { versaExcelExportSheets } from "./products/versa";
import { ExcelExportSheetConfig } from "./types";

const sheetsByProduct: Partial<Record<ProductEnum, ExcelExportSheetConfig[]>> =
  {
    [ProductEnum.VERSA]: versaExcelExportSheets,
    [ProductEnum.TEST]: versaExcelExportSheets,
    [ProductEnum.GOLF]: golfExcelExportSheets,
    [ProductEnum.SPA]: spaExcelExportSheets,
    [ProductEnum.RETAIL]: retailExcelExportSheets,
    [ProductEnum.SALES_AND_CATETING]: sncExcelExportSheets,
    [ProductEnum.RESERVE_ACTIVITIES]: reserveExcelExportSheets,
    [ProductEnum.RESERVE_DINING]: reserveExcelExportSheets,
  };

/** Returns payload-key → sheet config for the given product. */
export const getExcelExportSheetConfigMap = (
  productId: number,
): Record<string, ExcelExportSheetConfig> => {
  const sheets = getExcelExportSheets(productId);
  return Object.fromEntries(sheets.map((sheet) => [sheet.payloadKey, sheet]));
};

/** Ordered sheet config array for the given product (stable export/import order). */
export const getExcelExportSheets = (
  productId: number,
): ExcelExportSheetConfig[] => {
  const productType = getProductType(productId) as ProductEnum | undefined;
  return productType ? (sheetsByProduct[productType] ?? []) : [];
};
